import React from 'react'
import SectionOne from '../components/SectionOne'
import SectionTwo from '../components/SectionTwo'


export default function Home() {
  return (
    <>
      <SectionOne/>
      <SectionTwo/>
    </>
  )
}
